import { render, staticRenderFns } from "./TestCard.vue?vue&type=template&id=3601dacd&scoped=true"
import script from "./TestCard.vue?vue&type=script&lang=ts"
export * from "./TestCard.vue?vue&type=script&lang=ts"
import style0 from "./TestCard.vue?vue&type=style&index=0&id=3601dacd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3601dacd",
  null
  
)

export default component.exports